import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import {
  Button,
  Heading,
  Paragraph,
  ParagraphWeights,
  PlusIcon,
  useNoSSRBreakpointValue,
} from 'ui-components';
import { useAddTalentStore } from '~/screens/AddTalent';

interface IGradientEmptyPageProps {
  infoText: string;
  redirectUrl?: string;
  buttonText?: string;
}

export const GradientEmptyPage: React.FC<IGradientEmptyPageProps> = ({
  infoText,
  redirectUrl,
  buttonText = 'Add talent',
}) => {
  const { setIsModalOpen: openNewAddTalentModal } = useAddTalentStore();
  const router = useRouter();
  const isMobile = useNoSSRBreakpointValue({ base: true, md: false });
  const isDesktop = useNoSSRBreakpointValue({
    base: false,
    md: true,
  });
  const GRADIENT_HEIGHT = !isDesktop ? '260px' : '210px';

  const handleOpenAddTalent = useCallback(() => {
    if (redirectUrl) {
      router.push(redirectUrl);
      return;
    }
    openNewAddTalentModal(true);
  }, [openNewAddTalentModal, redirectUrl, router]);

  return (
    <Box
      __css={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height: `calc(100dvh - ${GRADIENT_HEIGHT})`,
        pointerEvents: 'none',
        background:
          'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 84.5%, #FFF 100%)',
      }}
    >
      <Flex
        position="absolute"
        bottom={0}
        left="50%"
        width={{ base: '24rem', md: '36rem', lg: '46rem' }}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={6}
        marginX="auto"
        textAlign="center"
        pointerEvents="all"
        transform="translateX(-50%)"
        padding={10}
      >
        {isMobile ? (
          <Paragraph size="lg" fontWeight={ParagraphWeights.Medium}>
            {infoText}
          </Paragraph>
        ) : (
          <Heading size="md">{infoText}</Heading>
        )}

        <Button leftIcon={<PlusIcon />} size="md" onClick={handleOpenAddTalent}>
          {buttonText}
        </Button>
      </Flex>
    </Box>
  );
};
